import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { isAU, ORG } from 'js/constants/crux';
import Commons from '../../../helpers/Commons';
import SEGMENT from '../../../constants/segment';
import Reports from '../../../constants/reports';

const FOOTER_NAME = isAU ? `${ORG} RP Data.` : `${ORG} Property Guru.`;

const ShareReport = (props) => {
    const {
        cesLink, cesLinkExpiry,
        propertyAddress, onClickEventLogger,
        type,
    } = props;

    const openMailToFirefox = (mailToUrl) => {
        // create iframe to load mailto link
        // prevent loading mailto on the same page
        // target _blank is known issue for mailto in FF
        const mailToFrame = document.createElement('iframe');
        mailToFrame.className = 'share-report-iframe';
        mailToFrame.src = mailToUrl;
        mailToFrame.style.cssText = 'display: none';
        document.body.appendChild(mailToFrame);
        setTimeout(() => {
            document.body.removeChild(mailToFrame); // cleanup
        }, 1);
    };

    const openMailToDefault = (mailToUrl) => {
        const mailToLink = document.createElement('a');
        mailToLink.className = 'share-report-anchor';
        mailToLink.target = '_blank';
        mailToLink.rel = 'noopener noreferrer';
        mailToLink.style.cssText = 'display: none';
        mailToLink.href = mailToUrl;
        document.body.appendChild(mailToLink);
        mailToLink.click();
        document.body.removeChild(mailToLink);
    };

    const shareReport = () => {
        const SUBJECT_TYPE_VALUE = {
            [Reports.CES_REPORT_TYPES.digitalReport]: SEGMENT.EVENT_PROPERTIES.DIGITAL_PROPERTY_REPORT,
            [Reports.CES_REPORT_TYPES.equityCalculatorReport]: SEGMENT.EVENT_PROPERTIES.EQUITY_CALCULATOR_REPORT,
        };
        const REPORT_TYPE_VALUE = {
            [Reports.CES_REPORT_TYPES.digitalReport]: SEGMENT.EVENT_PROPERTIES.DIGITAL_PROPERTY_PROFILE_REPORT,
            [Reports.CES_REPORT_TYPES.equityCalculatorReport]: SEGMENT.EVENT_PROPERTIES.EQUITY_CALCULATOR_REPORT,
        };
        const expiryDate = Commons.formatDate(cesLinkExpiry, 'DD MMM YYYY');
        const subject = `${SUBJECT_TYPE_VALUE[type]} - ${propertyAddress}`;
        const addressHeading = `${REPORT_TYPE_VALUE[type]} - ${propertyAddress}`;
        const footer = `Generated by ${FOOTER_NAME} Please note that this link will expire on ${expiryDate}.`;
        const emailBody = [
            addressHeading, cesLink, '', footer,
        ].join('\r\n');

        const mailToUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
        if (isFirefox) {
            openMailToFirefox(mailToUrl);
        } else {
            openMailToDefault(mailToUrl);
        }
        onClickEventLogger(SEGMENT.EVENT_NAMES.SHARE_REPORT);
    };

    return (
        <Button
            variant="contained"
            color="primary"
            className="share-button"
            onClick={shareReport}
        >
            <span>Share</span>
        </Button>
    );
};

ShareReport.propTypes = {
    propertyAddress: PropTypes.string,
    cesLink: PropTypes.string,
    cesLinkExpiry: PropTypes.string,
    onClickEventLogger: PropTypes.func,
};

export default ShareReport;
